import { z } from 'zod';

export const DataSchema = z.array(
    z.object({
        value: z.number(),
        name: z.string(),
    })
);
export type DataType = z.infer<typeof DataSchema>;
